<template>
    <AuthLayout>
        <div class="flex  ">
            <Toast />
            <!-- Left Section: Image -->
            <div class="hidden lg:block lg:w-7/12">
                <img src="@/assets/left-side.jpg" alt="Welcome Image"
                    class="h-full w-full object-cover object-center " />
            </div>
            <!-- Right Section: Register Form -->
            <div id="right-side-container"
                class="flex flex-col justify-start items-center w-full lg:w-5/12 logged-out-container  overflow-y-auto max-h-screen pb-8 overscroll-y-contain">

                <div class="flex flex-col justify-start items-center w-full max-w-lg mt-1">
                    <h1 class="welcome-back">REGISTER</h1>
                    <p class="subtitle pb-2 text-sm">it only takes a minute</p>
                </div>

                <div id="stepper-parent" class="flex flex-col justify-start items-center w-full max-w-lg ">
                    <Stepper v-model:value="activeStep" class="w-11/12 ">
                        <div class="flex flex-col justify-start items-center w-full max-w-md relative mt-1 ">
                            <div class="card flex ">
                                <div class="flex flex-col ">
                                    <div class="flex flex-row justify-center">
                                        <StepList>
                                            <Step v-slot="{ value, a11yAttrs }" asChild :value="1">
                                                <div class="flex flex-row items-center" v-bind="a11yAttrs.root">
                                                    <button class="bg-transparent border-0 inline-flex" @click.prevent
                                                        v-bind="a11yAttrs.header" :disabled="true">
                                                        <span
                                                            :class="['rounded-full w-5 h-5 inline-flex items-center justify-center bg-[var(--secondary-background-color)]']">
                                                            <span
                                                                :class="[{ 'bg-green-500 rounded-full w-3 h-3': value <= activeStep }]"></span>
                                                        </span>
                                                    </button>
                                                    <div :class="[
                                                        'h-1 w-28',
                                                        value <= activeStep - 1 ? 'bg-green-500' : 'bg-[var(--secondary-background-color)]'
                                                    ]" />
                                                </div>
                                            </Step>

                                            <Step v-slot="{ activateCallback, value, a11yAttrs }" asChild :value="2">
                                                <div class="flex flex-row items-center" v-bind="a11yAttrs.root">
                                                    <button class="bg-transparent border-0 inline-flex" @click.prevent
                                                        v-bind="a11yAttrs.header" :disabled="true">
                                                        <span
                                                            :class="['rounded-full w-5 h-5 inline-flex items-center justify-center bg-[var(--secondary-background-color)]']">
                                                            <span :class="[{ 'bg-green-500 rounded-full w-3 h-3': value <= activeStep }]">

                                                            </span>
                                                        </span>
                                                    </button>
                                                    <div :class="[
                                                        'h-1 w-28',
                                                        value <= activeStep - 1 ? 'bg-green-500' : 'bg-[var(--secondary-background-color)]'
                                                    ]" />
                                                </div>
                                            </Step>

                                            <Step v-slot="{ activateCallback, value, a11yAttrs }" asChild :value="3">
                                                <div class="flex flex-row items-center" v-bind="a11yAttrs.root">
                                                    <button class="bg-transparent border-0 inline-flex" @click.prevent
                                                        v-bind="a11yAttrs.header" :disabled="true">
                                                        <span
                                                            :class="['rounded-full w-5 h-5 inline-flex items-center justify-center bg-[var(--secondary-background-color)]']">
                                                            <span :class="[{ 'bg-green-500 rounded-full w-3 h-3': value <= activeStep }]">

                                                            </span>
                                                        </span>
                                                    </button>
                                                </div>
                                            </Step>
                                        </StepList>
                                    </div>

                                    <div class="flex flex-row justify-between items-end">
                                        <div class="secondary-text">Step 1</div>
                                        <div class="secondary-text">Step 2</div>
                                        <div class="secondary-text">Complete</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="vipPromo" class="text-white text-sm items-center text-center mt-3 ">
                            <div class="flex text-sm justify-center items-center">
                                Register now to qualify for <div class="font-bolyar px-1 py-1 pb-2"> 30% OFF </div>
                                commissions.
                            </div>

                            <div class="text-xs">To keep discount after second month, minimum of 35 FTD's is required.
                            </div>
                        </div>

                        <div class="flex flex-col rounded-lg w-full shadow-lg bg-[var(--secondary-background-color)] mt-5  2xl:mt-20 relative"
                            :class="{ 'min-h-[569.5px]': activeStep !== 3 }">
                            <StepPanels class="relative">
                                <StepPanel v-slot="{ activateCallback }" :value="1">
                                    <div
                                        class="flex flex-col bg-[var(--secondary-background-color)] px-8 register-form">
                                        <div id="name-section" class="flex flex-col w-full">
                                            <label class="text-white" for="name">Full Name</label>
                                            <IconField class="pt-1">
                                                <InputText id="name" v-model="form.name" :invalid="errors.name !== null"
                                                    name="name" placeholder="Full name" class="w-full pt-1" required
                                                    autofocus />
                                            </IconField>
                                        </div>
                                        <div id="phone-section" class="flex flex-col mt-1">
                                            <label class="text-white" for="phone">Skype/Telegram/Whatsapp</label>
                                            <div class="flex items-center">
                                                <!-- Phone Prefix and Number Input -->
                                                <div class="flex items-center w-full">
                                                    <InputGroup>
                                                        <InputGroupAddon class="!bg-transparent">
                                                            <i class="pi pi-telegram w-7 mx-auto ml-3 "></i>
                                                        </InputGroupAddon>
                                                        <InputText id="contact" v-model="form.contact"
                                                             name="contact" fluid
                                                            class="w-full" :useGrouping="false" />
                                                    </InputGroup>
                                                </div>
                                            </div>
                                        </div>
                                        <div id="country-section" class="flex pt-1 mt-1">
                                            <div class="flex flex-col pt-1 w-full">
                                                <label class="text-white" for="country">Country</label>
                                                <IconField>
                                                    <div class="card flex justify-start">
                                                        <Select v-model="form.country" filter :options="countries"
                                                            :invalid="errors.country !== null" optionLabel="name"
                                                            placeholder="Select a Country" class="w-full"
                                                            :virtualScrollerOptions="{ itemSize: 30 }"
                                                            @change="handleCountryChange">
                                                            <!-- Selected Value Template -->
                                                            <template #value="slotProps">
                                                                <div v-if="slotProps.value" class="flex items-center">
                                                                    <span
                                                                        :class="`fi fi-${slotProps.value.code.toLowerCase()}`"
                                                                        class="mr-2"></span>
                                                                    <div>{{ slotProps.value.name }}</div>
                                                                </div>
                                                                <span v-else>
                                                                    {{ slotProps.placeholder }}
                                                                </span>
                                                            </template>

                                                            <!-- Option Template -->
                                                            <template #option="slotProps">
                                                                <div class="flex items-center">
                                                                    <span
                                                                        :class="`fi fi-${slotProps.option.code.toLowerCase()}`"
                                                                        class="mr-2"></span>
                                                                    <div>{{ slotProps.option.name }}</div>
                                                                </div>
                                                            </template>
                                                        </Select>
                                                    </div>
                                                </IconField>
                                            </div>
                                        </div>
                                        <div id="email-section" class="flex pt-1 mt-1">
                                            <div class="flex flex-col pt-1 w-full">
                                                <label class="text-white" for="email">Email</label>
                                                <IconField class="pt-1">
                                                    <InputText id="email" v-model="form.email" name="email"
                                                        :invalid="errors.email !== null" placeholder="Your Email"
                                                        class="md:w-1/2" required fluid />
                                                </IconField>
                                                <small class="error" v-if="errors.email">{{ errors.email }}</small>
                                                <small class="error" v-if="errors.emailExists">{{ errors.emailExists
                                                    }}</small>
                                            </div>
                                        </div>
                                        <div id="password-section" class="flex pt-1 mt-1">
                                            <div class="flex flex-col w-full">
                                                <label class="text-white" for="password">Password</label>
                                                <div class="pt-1 w-full">
                                                    <Password id="password" v-model="form.password" name="password"
                                                        :feedback="false" :invalid="errors.password !== null" fluid
                                                        required toggleMask />
                                                </div>
                                                <small class="error" v-if="errors.password">{{ errors.password
                                                    }}</small>
                                            </div>
                                        </div>
                                        <div id="confirm-password-section" class="flex pt-1 mt-1">
                                            <div class="flex flex-col pt-1 w-full">
                                                <label class="text-white" for="password">Confirm Password</label>
                                                <div class="pt-1 w-full">
                                                    <Password id="password" v-model="form.confirmPassword"
                                                        :feedback="false" name="password"
                                                        :invalid="errors.confirmPassword !== null" required toggleMask
                                                        fluid />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="flex justify-end mt-6">
                                            <Button label="Next" icon="pi pi-arrow-right" iconPos="right"
                                                :disabled="!isStep1NextClickable" severity="primary"
                                                class="font-bolyar cursor-pointer"
                                                @click="() => handleStep1To2(activateCallback)"
                                                v-tooltip.bottom="!isStep1NextClickable ? step1TooltipMessage : ''" />
                                        </div>
                                    </div>
                                </StepPanel>
                                <StepPanel v-slot="{ activateCallback }" :value="2">
                                    <div
                                        class="flex flex-col bg-[var(--secondary-background-color)] px-8 register-form">
                                        <div id="company-select-section" class="flex flex-col w-full">
                                            <div class="flex flex-row justify-between items-start gap-4">
                                                <div class="flex flex-col">
                                                    <label class="text-white" for="type">Account type</label>
                                                    <SelectButton v-model="form.type" :options="accountTypeOptions"
                                                        aria-labelledby="basic" class="w-26 pt-1 h-10" />
                                                </div>
                                                <div v-if="form.type === 'Company'" class="flex flex-col">
                                                    <div class="items-center">
                                                        <label class="text-white" for="vatExempt"
                                                            v-tooltip.left="'If you pay VAT, then make sure this is toggled'">
                                                            VAT Exempt
                                                        </label>
                                                    </div>
                                                    <div class="flex justify-center items-center pt-3">
                                                        <ToggleSwitch v-model="form.vatExempt" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div id="conmpany-details-section" v-if="form.type === 'Company'"
                                            class="flex flex-col w-full mt-1">
                                            <div class="flex flex-row justify-between items-start gap-4">
                                                <div class="flex flex-col">
                                                    <label class="text-white" for="companyName">Company Name</label>
                                                    <InputText id="companyName" v-model="form.companyName"
                                                        :invalid="errors.companyName !== null" name="companyName"
                                                        placeholder="Company Name" class="w-full" required />
                                                </div>
                                                <div class="flex flex-col">
                                                    <label class="text-white" for="vat">VAT number</label>
                                                    <InputText id="vat" v-model="form.vat"
                                                        :invalid="errors.vat !== null" name="vat"
                                                        placeholder="Vat number" class="w-full" required
                                                        maxlength="20" />
                                                </div>
                                            </div>
                                        </div>
                                        <div id="street-address-section" class="flex flex-col w-full mt-1">
                                            <label class="text-white" for="street">Street address</label>
                                            <InputText id="street" v-model="form.street"
                                                :invalid="errors.street !== null" placeholder="Your Address"
                                                class="w-full" required />
                                        </div>
                                        <div id="city-section" class="flex flex-col w-full mt-1">
                                            <label class="text-white" for="city">City</label>
                                            <InputText id="city" v-model="form.city" :invalid="errors.city !== null"
                                                placeholder="City" class="w-full" required />
                                        </div>
                                        <div id="country-section" class="flex flex-col w-full mt-1">
                                            <label class="text-white" for="addressCountry">Country</label>
                                            <Select v-model="form.addressCountry" filter :options="countries"
                                                :invalid="errors.addressCountry !== null" optionLabel="name"
                                                placeholder="Select Country" class="w-full pt-1"
                                                :virtualScrollerOptions="{ itemSize: 30 }">
                                                <template #value="slotProps">
                                                    <div v-if="slotProps.value" class="flex items-center">
                                                        <span :class="`fi fi-${slotProps.value.code.toLowerCase()}`"
                                                            class="mr-2">
                                                        </span>
                                                        <div>{{ slotProps.value.name }}</div>
                                                    </div>
                                                    <span v-else>
                                                        {{ slotProps.placeholder }}
                                                    </span>
                                                </template>
                                                <template #option="slotProps">
                                                    <div class="flex items-center">
                                                        <span :class="`fi fi-${slotProps.option.code.toLowerCase()}`"
                                                            class="mr-2"></span>
                                                        <div>{{ slotProps.option.name }}</div>
                                                    </div>
                                                </template>
                                            </Select>
                                        </div>
                                        <div id="traffic-geo-section" class="flex flex-col w-full mt-1">
                                            <label class="text-white" for="trafficSource">Geo sources</label>
                                            <MultiSelect v-model="form.trafficGeo" :options="trafficGeoOptions"
                                                optionLabel="name" optionValue="code" placeholder="Target Geo's"
                                                class="w-full" :maxSelectedLabels="2"
                                                :selectedItemsLabel="'{count} geos selected'">
                                                <!-- Selected Value Template -->
                                                <template #value="slotProps">
                                                    <div v-if="slotProps.value?.length" class="flex flex-wrap gap-2">
                                                        <template v-if="slotProps.value.length <= 2">
                                                            <div v-for="option of slotProps.value" :key="option"
                                                                class="flex items-center">
                                                                <span
                                                                    :class="option.toLowerCase() == 'int' ? 'fa-solid fa-globe' : `fi fi-${option.toLowerCase()}`"
                                                                    class="mr-2"></span>
                                                                <div>{{trafficGeoOptions.find(x => x.code ===
                                                                    option)?.name}}</div>
                                                            </div>
                                                        </template>
                                                        <span v-else>
                                                            {{ slotProps.value.length }} geos selected
                                                        </span>
                                                    </div>
                                                    <span v-else class="text-gray-400">
                                                        Target Geo's
                                                    </span>
                                                </template>
                                                <!-- Option Template -->
                                                <template #option="slotProps">
                                                    <div class="flex items-center">
                                                        <span
                                                            :class="slotProps.option.code.toLowerCase() === 'int' ? 'fa-solid fa-globe' : `fi fi-${slotProps.option.code.toLowerCase()}`"
                                                            class="mr-2"></span>
                                                        <div>{{ slotProps.option.name }}</div>
                                                    </div>
                                                </template>
                                            </MultiSelect>
                                            <small class="error" v-if="errors.trafficGeo">{{ errors.trafficGeo
                                                }}</small>
                                        </div>
                                        <div id="traffic-source-section" class="flex flex-col w-full mt-1">
                                            <label class="text-white" for="trafficSource">Traffic sources</label>
                                            <MultiSelect v-model="form.trafficSource" :options="trafficSourceOptions"
                                                placeholder="Target traffic" optionLabel="name" optionValue="code"
                                                class="w-full" :maxSelectedLabels="2"
                                                :selectedItemsLabel="'{count} sources selected'"
                                                :optionDisabled="isOptionDisabled" />
                                            <small class="error" v-if="errors.trafficSource">{{ errors.trafficSource
                                                }}</small>
                                        </div>
                                        <div class="flex pt-6 justify-between">
                                            <Button label="Back" severity="secondary" icon="pi pi-arrow-left"
                                                @click="activateCallback(1)" class="font-bolyar">
                                                <div class="flex items-center text-white">
                                                    <span class="pi pi-arrow-left mr-2" />
                                                    Back
                                                </div>
                                            </Button>
                                            <Button :loading="isLoading" :disabled="!isStep2NextClickable"
                                                @click="handleStep2To3(activateCallback)"
                                                class="submit-button w-2/5 font-bolyar"
                                                v-tooltip.bottom="step2TooltipMessage" severity="primary">
                                                <span>Next </span>
                                                <img src="@/assets/icons/login-icon.svg" alt="" class="w-5 h-5 ml-2" />
                                            </Button>
                                        </div>
                                    </div>
                                </StepPanel>
                                <StepPanel :value="3">
                                    <div
                                        class="flex flex-col items-center justify-center bg-[var(--secondary-background-color)] p-8 text-center">
                                        <img src="@/assets/icons/completed-logo-register.svg"
                                            alt="Registration Complete" class="w-20 h-20 mb-6" />
                                        <h2 class="text-2xl font-bold mt-5 text-white text-center">
                                            Registration Almost Complete
                                        </h2>
                                        <p class="text-white text-center max-w-sm mt-10">
                                            Please check your email inbox to confirm your account and login.
                                        </p>
                                        <p class="text-gray-400 text-sm text-center max-w-sm mt-4">
                                            Can't find the email? Please check your spam/junk folder or wait a few
                                            seconds for it to arrive.
                                        </p>
                                    </div>
                                </StepPanel>
                            </StepPanels>
                        </div>
                    </Stepper>
                    <div class="text-center mt-2 text-sm">
                        <router-link to="/login" class="text-blue-500 hover:underline font-bolyar [&]:cursor-pointer">
                            Login
                        </router-link>
                    </div>
                </div>
            </div>
        </div>

        <TermsDialog v-model:visible="termsDialogVisible" v-model:acceptedTerms="acceptedTerms" :type="form.type"
            :companyName="form.companyName" @signature="handleSignature" />

    </AuthLayout>
</template>

<script setup>
import { ref, watch, computed, reactive, onMounted } from 'vue';
import AuthLayout from '@/views/AuthLayout.vue';
import TermsDialog from './TermsDialog.vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import AuthService from '@/services/AuthService';
import { getSiteTypes } from '@/utils/siteTypes';
const store = useStore();
const router = useRouter();
const route = useRoute();
import phoneCountries from '@/utils/phoneCountries';
const phoneSelectedCountry = ref({ name: '+356 (Malta)', code: 'mt', prefix: '+356' });

// Validation logic
const errors = reactive({
    name: null,
    email: null,
    password: null,
    confirmPassword: null,
    emailExists: false,
    contact: null,
    country: null,
    street: null,
    city: null,
    vat: null,
    addressCountry: null,
    trafficSource: null,
    trafficGeo: null,
    companyName: null,
});

const isOptionDisabled = (option) => {
    // If SEO is selected, disable all other options
    if (form.trafficSource.includes('seo')) {
        return option.code !== 'seo'
    }

    // If any other option is selected, disable SEO
    if (form.trafficSource.length > 0) {
        return option.code === 'seo'
    }

    return false // Nothing is disabled by default
}

const handleCountryChange = (e) => {
    // Set address country to match selected country if it's not already set
    if (!form.addressCountry || form.addressCountry === form.country) {
        form.addressCountry = e.value
    }
}
// const emailExists = ref(false)
// // Reactive references for form data
const isLoading = ref(false)

const form = reactive({
    name: '',
    email: '',
    phone: '',
    contact: '',
    country: '',
    password: '',
    confirmPassword: '',
    type: 'Individual',
    vat: '',
    street: '',
    city: '',
    addressCountry: '',
    trafficSource: '',
    companyName: '',
    vatExempt: false,
});

import countries from '@/utils/countries';
import { markets } from '@/utils/markets';
const accountTypeOptions = ref(['Individual', 'Company']);

const trafficSourceOptions = ref(getSiteTypes());

const trafficGeoOptions = computed(() => {
    return markets.map(code => {
        const country = countries.value.find(c => c.code === code);
        return {
            code: code,
            name: country ? country.name : code,
            flag: code.toLowerCase() // for flag icons
        };
    });
});

// Register function, now as a standalone method
const register = async (signatureImage, representativeName) => {
    isLoading.value = true;
    try {
        const userData = {
            email: form.email,
            name: form.name,
            password: form.password,
            contact: form.contact,
            country: form.country.code,
            vatExempt: form.vatExempt,
            addressCountry: form.addressCountry.code,
            street: form.street,
            city: form.city,
            type: form.type,
            trafficSource: form.trafficSource,
            trafficGeo: form.trafficGeo,
            representativeName: representativeName,
            isVip: vipPromo.value,
            linkedinId: linkedinId.value,
        };

        // Only include company-specific fields if account type is Company
        if (form.type === 'Company') {
            userData.companyName = form.companyName;
            userData.vat = form.vat;
        }
        await AuthService.register(userData, signatureImage);
        errors.emailExists = null;
        activeStep.value = 3;
        toast.add({
            severity: 'success',
            summary: 'Registration successful',
            detail: 'Please check your email inbox to confirm your account and login.',
            life: 5000
        });
    } catch (err) {
        console.error('Err:', err.response);
        acceptedTerms.value = false;
    }
    isLoading.value = false;
};
//validate steps
const activeStep = ref(1);

const isStep1NextClickable = computed(() => {
    return Boolean(
        form.name?.trim() &&
        // form.contact &&
        form.country &&
        form.email?.trim() &&
        form.password?.trim() &&
        form.confirmPassword?.trim() &&
        form.password === form.confirmPassword
    );
});

const isStep1Valid = async () => {
    errors.name = form.name.length >= 1
        ? null
        : 'Name required';

    errors.email = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)
        ? null
        : 'Invalid email address.';

    errors.country = form.country
        ? null
        : 'Country required';

    errors.password = form.password.length >= 5
        ? null
        : 'Password must be at least 5 characters long.';

    try {
        console.log('Checking email exists', form.email);
        const emailExistsReponse = await AuthService.checkEmailExists(form.email);
        console.log(emailExistsReponse);
    } catch (err) {
        if (err.response.status == 409) {
            errors.email = 'Email already exists';
        }
        console.error('Err:', err.response);
    }
    return !errors.name &&
        !errors.email &&
        !errors.country &&
        !errors.password;

};

const step1TooltipMessage = computed(() => {
    if (form.password && form.confirmPassword && form.password !== form.confirmPassword) {
        return 'Passwords do not match';
    }
    return 'Please fill in all required fields';
});

const isStep2NextClickable = computed(() => {
    const baseValidation = Boolean(
        form.street?.trim() &&
        form.city?.trim() &&
        form.addressCountry &&
        form.trafficGeo?.length > 0 &&
        form.trafficSource?.length > 0
    );

    if (form.type === 'Company') {
        return baseValidation && Boolean(
            form.companyName?.trim() &&
            form.vat?.trim()
        );
    }

    return baseValidation;
});

const step2TooltipMessage = computed(() => {
    const activeErrors = [];

    // Collect all active errors
    if (errors.street) activeErrors.push(errors.street);
    if (errors.city) activeErrors.push(errors.city);
    if (errors.addressCountry) activeErrors.push(errors.addressCountry);
    if (errors.trafficGeo) activeErrors.push('Select at least one traffic geography');
    if (errors.trafficSource) activeErrors.push('Select at least one traffic source');

    // Company-specific errors
    if (form.type === 'Company') {
        if (errors.companyName) activeErrors.push(errors.companyName);
        if (errors.vat) activeErrors.push(errors.vat);
    }

    // If there are validation errors, show them regardless of clickable state
    if (activeErrors.length > 0) {
        return activeErrors[0];
    }

    // If no errors but button not clickable, show generic message
    if (!isStep2NextClickable.value) {
        return 'Please fill in all required fields';
    }

    return '';
});

const isStep2Valid = () => {
    errors.street = form.street.length >= 5
        ? null
        : 'Street address must be at least 5 characters long.';

    errors.city = form.city.length >= 2
        ? null
        : 'City name must be at least 2 characters long.';

    errors.addressCountry = form.addressCountry
        ? null
        : 'Country required';

    errors.trafficGeo = form.trafficGeo?.length > 0
        ? null
        : 'Please select at least one';

    errors.trafficSource = form.trafficSource?.length > 0
        ? null
        : 'Please select at least one';

    // VAT validation only for Company type
    if (form.type === 'Company') {
        errors.companyName = form.companyName?.length >= 1
            ? null
            : 'Company name is required';

        errors.vat = form.vat && form.vat.replace(/[-_]/g, '').length >= 2
            ? null
            : 'VAT number is required';

        // Return false if any error exists (including VAT and company name)
        return !Object.values(errors).some(error => error !== null && error !== false);
    }

    // For Individual accounts, check all validations except VAT and company name
    return !errors.street &&
        !errors.city &&
        !errors.addressCountry &&
        !errors.trafficSource &&
        !errors.trafficGeo;
};

const handleStep1To2 = async (callback) => {
    const isValid = await isStep1Valid();
    if (isValid) {
        callback(2);
    }
};

const handleStep2To3 = (callback) => {
    const isValid = isStep2Valid();
    console.log(form);
    if (isValid) {
        termsDialogVisible.value = true;
    }
};

//terms and conditions and signature
const acceptedTerms = ref(false);
const termsDialogVisible = ref(false);

const handleSignature = async ({ signatureImage, representativeName }) => {
    await register(signatureImage, representativeName);
}

const vipPromo = ref(false);
const linkedinId = ref('');
// Check for VIP promo parameter on component mount
onMounted(() => {
    // Check if vip_promo=true parameter exists in the URL
    if (route.query.vip_promo == 'true') {
        vipPromo.value = true;
    }

    if (route.query.li_fat_id) {
        linkedinId.value = route.query.li_fat_id;
    }
});

</script>

<style scoped>
.subtitle {
    color: #9B9BA3;
}

.register-form {
    font-size: 15px !important;
}

.logged-out-container {
    background-image: url('@/assets/right-side-background.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    height: 90svh;
}

.secondary-text {
    color: #64646d;
}

#right-side-container {
    -webkit-overflow-scrolling: touch;
    /* Smooth scrolling on iOS */
    height: 100svh;
    /* Explicit height */
    position: relative;
    /* Establish positioning context */
}

/* Prevent body scrolling when container is scrollable */
:deep(.logged-out-container) {
    overscroll-behavior-y: contain;
}

/* iOS specific fix */
@supports (-webkit-touch-callout: none) {
    #right-side-container {
        height: -webkit-fill-available;
    }
}
</style>